var map = {
	"./about-us.svg": 755,
	"./betting-icon.svg": 756,
	"./bonus.svg": 757,
	"./coin.svg": 758,
	"./contact-us.svg": 759,
	"./download-app.svg": 760,
	"./edit-btn.svg": 761,
	"./feedback.svg": 762,
	"./global.svg": 763,
	"./info-centre.svg": 764,
	"./info-centre.webp": 1633,
	"./instant-rebate.svg": 765,
	"./mall-icon.svg": 766,
	"./message.svg": 767,
	"./personal-info-edit.svg": 768,
	"./r77-coin.svg": 769,
	"./r77-rewards.svg": 770,
	"./redemption-icon.svg": 771,
	"./referral.svg": 772,
	"./resp-gaming.svg": 773,
	"./security.svg": 774,
	"./transaction-icon.svg": 775,
	"./vip-icon.svg": 776,
	"./wallet-icon.svg": 777
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 754;